import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faXmark } from "@fortawesome/free-solid-svg-icons";
import { SavedFilterEntry } from "./useSavedFilters";
import styles from "./styles.module.scss";

// ── Sekcja „Twoje filtry" wewnątrz prawego slajdu „Filtr" ───────────────────
//
// Prezentuje listę zapisanych kombinacji (klik = zastosuj, ✕ = usuń) oraz
// mechanizm zapisu bieżących ustawień pod etykietą. Kryteria trzyma rodzic —
// tu operujemy wyłącznie na etykiecie i callbackach.

interface Props<T> {
  saved: SavedFilterEntry<T>[];
  onApply: (criteria: T) => void;
  onDelete: (id: string) => void;
  /** Zapis bieżących ustawień pod podaną etykietą (rodzic dokłada kryteria). */
  onSave: (name: string) => void;
  /** Czy jest cokolwiek do zapisania (aktywne filtry). Blokuje przycisk zapisu. */
  canSave: boolean;
}

function SavedFiltersSection<T>({
  saved,
  onApply,
  onDelete,
  onSave,
  canSave,
}: Props<T>) {
  const [showNameInput, setShowNameInput] = useState(false);
  const [name, setName] = useState("");

  const handleSave = () => {
    if (!showNameInput) {
      setShowNameInput(true);
      return;
    }
    onSave(name);
    setName("");
    setShowNameInput(false);
  };

  return (
    <div className={styles.section}>
      <span className={styles.sectionLabel}>Twoje filtry</span>

      {saved.length === 0 ? (
        <div className={styles.empty}>Brak zapisanych filtrów</div>
      ) : (
        <div className={styles.list}>
          {saved.map((f) => (
            <div
              key={f.Id}
              className={styles.item}
              onClick={() => onApply(f.Criteria)}
              title="Zastosuj filtr"
            >
              <span className={styles.itemName}>{f.Name}</span>
              <button
                className={styles.del}
                title="Usuń filtr"
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete(f.Id);
                }}
              >
                <FontAwesomeIcon icon={faXmark} />
              </button>
            </div>
          ))}
        </div>
      )}

      <div className={styles.saveRow}>
        {showNameInput && (
          <input
            className={styles.nameInput}
            placeholder="Nazwa filtra"
            value={name}
            onChange={(e) => setName(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") handleSave();
              if (e.key === "Escape") {
                setShowNameInput(false);
                setName("");
              }
            }}
            autoFocus
          />
        )}
        <button
          className={styles.saveBtn}
          onClick={handleSave}
          disabled={!canSave}
          title={
            canSave
              ? "Zapisz bieżące ustawienia jako filtr"
              : "Ustaw filtry, aby zapisać"
          }
        >
          <FontAwesomeIcon icon={faPlus} />
          {showNameInput ? "Zapisz" : "Zapisz bieżące jako…"}
        </button>
      </div>
    </div>
  );
}

export default SavedFiltersSection;
